import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Services from './components/Services';
import CharityEvents from './components/CharityEvents';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <About />
      <Gallery />
      <Services />
      <CharityEvents />
      <Contact />
    </div>
  );
}